var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.988 9.256a.61.61 0 0 1-.616-.612V1.172c0-.348.263-.607.616-.607s.617.259.617.607v7.472a.61.61 0 0 1-.617.612m3.515 0a.613.613 0 0 1-.621-.612V1.172a.6.6 0 0 1 .621-.607c.348 0 .617.259.617.607v7.472a.61.61 0 0 1-.617.612"
  })));
};
export default SvgPause;